import React from 'react'

export function ConditionalWrapper({ condition, wrapper, children }) {
    return condition ? wrapper(children) : children
}
